import React from "react";

const StarRating = ({ rating, reviewCount, size = "sm" }) => {
  const pct = (rating / 5) * 100;
  const starSize = size === "sm" ? 13 : 16;

  return (
    <div className={`flex items-center gap-1.5 ${size === "sm" ? "text-xs" : "text-sm"}`}>
      {/* SVG star strip — filled via clip-path for precise fractional stars */}
      <div className="relative flex" style={{ width: starSize * 5 + 4 * 2, height: starSize }}>
        {/* Empty stars */}
        <div className="flex gap-0.5 absolute inset-0">
          {Array.from({ length: 5 }).map((_, i) => (
            <svg key={i} width={starSize} height={starSize} viewBox="0 0 16 16" fill="none">
              <path d="M8 1l1.7 4.6H15l-4.2 3 1.6 4.9L8 11 3.6 13.5l1.6-4.9L1 5.6h5.3z"
                fill="#e5e7eb" />
            </svg>
          ))}
        </div>
        {/* Filled stars overlay */}
        <div className="flex gap-0.5 absolute inset-0 overflow-hidden" style={{ width: `${pct}%` }}>
          {Array.from({ length: 5 }).map((_, i) => (
            <svg key={i} width={starSize} height={starSize} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
              <path d="M8 1l1.7 4.6H15l-4.2 3 1.6 4.9L8 11 3.6 13.5l1.6-4.9L1 5.6h5.3z"
                fill="#f59e0b" />
            </svg>
          ))}
        </div>
      </div>

      <span className="font-display font-semibold text-gray-700">{rating.toFixed(1)}</span>
      {reviewCount !== undefined && (
        <span className="text-gray-400 font-sans">({reviewCount.toLocaleString()})</span>
      )}
    </div>
  );
};

export default StarRating;
